import { Component, HostBinding } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { css } from '@emotion/css';

@Component({
  selector: 'app-user-management',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './user-management.component.html',
})
export class UserManagementPage {
  @HostBinding('class') className = css({ flexGrow: 1 });
}
